export enum CustomerPerformanceRecordOrder {
	Referrals = "Referrals",
	Shares = "Shares",
	Clicks = "Clicks",
	Redemptions = "Redemptions"
}
